module.exports = __webpack_public_path__ + "img/Search.52501233.svg";